import { sanitiseUrl } from "@/lib/getFundURL";
import { useIsBelow } from "@/styles/breakpoints";
import type { PropsWithChildren } from "react";
import {
	additional,
	container,
	crumb as crumbStyle,
	crumbs as crumbsStyle,
	link as linkStyle,
} from "./Breadcrumbs.css";
import type { Props } from "./types";

export default function Breadcrumbs({
	crumbs,
	children,
	removeLastCrumb = true,
}: PropsWithChildren<Props>) {
	const isBelowM = useIsBelow("m");

	const sanitiseHref = (href: string) => {
		const url = new URL(href, window.location.origin);
		const sanitisedUrl = sanitiseUrl(url);
		return sanitisedUrl.toString();
	};

	return (
		<div className={container}>
			<ul className={crumbsStyle}>
				{crumbs
					.filter((c) => (removeLastCrumb ? !isBelowM || c.path : true))
					.map((c, i) => {
						const icon =
							c.icon && typeof c.icon === "string" ? (
								<img src={c.icon} alt={c.name} />
							) : (
								c.icon
							);
						const content = c.icon ? icon : c.name;
						const key = `crumb-${i}`;
						return (
							<li key={key} className={crumbStyle}>
								{c.path ? (
									<a href={sanitiseHref(c.path)} className={linkStyle}>
										{content}
									</a>
								) : (
									content
								)}
							</li>
						);
					})}
			</ul>
			<div className={additional}>{children}</div>
		</div>
	);
}
